import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { TmrODataConfiguration } from '@exchange/services/core/odata/config'
import { IModelBase } from 'common-components'
import { ODataService } from 'common-services'

export interface IReadyForPayment extends IModelBase {
  RemittanceId: number
  ServicePaymentId: number
  ServiceLineNumber: number
  Npi: string
  Name: string
  MarketName: string
  PayAmount: number
  ClaimId: number
  AdjudicationTypeId: number
  AdjudicationTypeName: string
  StatusId: number
  Status: string
  City: string
  State: string
  ZipCode: string
}

@Injectable()
export class ReadyToPayViewODataService extends ODataService<IReadyForPayment> {
  constructor(
    protected http: HttpClient,
    protected config: TmrODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ReadyForPaymentView'
  }
}
